import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FEATURED_CASE_STUDIES, PORTFOLIO_SITES } from "@/data/caseStudiesData";

const SITES = [...FEATURED_CASE_STUDIES, ...PORTFOLIO_SITES].map((s) => ({
  slug: s.slug,
  domain: s.domain,
  screenshot: s.screenshot,
}));

const StripCard = ({ site, hidden }) => (
  <Link
    to="/case-studies"
    tabIndex={hidden ? -1 : 0}
    aria-hidden={hidden || undefined}
    data-testid={hidden ? undefined : `client-strip-item-${site.slug}`}
    className="group/strip flex-shrink-0 w-[190px] sm:w-[220px]"
  >
    <div className="relative aspect-[16/10] overflow-hidden rounded-lg border border-white/10 bg-gray-900 group-hover/strip:border-[#00E676]/50 transition-colors">
      <img
        src={site.screenshot}
        alt={hidden ? "" : `${site.domain} website homepage preview`}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />
      <span className="absolute bottom-1.5 left-2.5 text-[11px] font-semibold text-white/90 truncate max-w-[90%]">
        {site.domain}
      </span>
    </div>
  </Link>
);

const ClientSitesStrip = () => (
  <section
    className="py-10 border-y border-white/[0.06] bg-white/[0.015]"
    aria-label="Client websites built by Digital Media Ninja"
    data-testid="client-sites-strip"
  >
    <div className="container-custom flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-6">
      <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest">
        <span className="text-[#00E676]">17 client sites</span> getting found on Google & AI search
      </p>
      <Link
        to="/case-studies"
        data-testid="client-strip-see-results-link"
        className="inline-flex items-center gap-1.5 text-sm font-bold text-[#00E676] hover:text-white transition-colors"
      >
        See the case studies <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </Link>
    </div>
    <div className="dmn-marquee overflow-hidden" role="presentation">
      <div className="dmn-marquee-track flex gap-4 w-max">
        {SITES.map((site) => (
          <StripCard key={site.slug} site={site} />
        ))}
        {SITES.map((site) => (
          <StripCard key={`dup-${site.slug}`} site={site} hidden />
        ))}
      </div>
    </div>
  </section>
);

export default ClientSitesStrip;
